(() => {
  'use strict';
  const config = document.getElementById('mst-crisp-config');
  if (!config) return;
  const d = config.dataset;
  if (!/^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i.test(d.websiteId)) return;
  const path = url => new URL(url, location.origin).pathname.replace(/\/$/, '');
  const contactPath = d.contactUrl ? path(d.contactUrl) : null;
  let activeLink = null;
  let previousContext = '';

  function messageFor(link) {
    const currentPath = path(location.href);
    const compatibility = d.productTitle || link.matches('.hero-atelier-help, .finder-help') || link.closest('.catalogue-advice, .product-help');
    const intro = d.installationUrl && currentPath === path(d.installationUrl) ? d.installation
      : d.materialsUrl && currentPath === path(d.materialsUrl) ? d.materials
      : compatibility ? d.compatibility : d.generic;
    const message = link.dataset.chatMessage || intro;
    // Only a product page adds a reference: the product being viewed, never a remembered vehicle.
    return d.productTitle ? `${message}\n${d.productLabel} : ${d.productTitle}` : message;
  }

  // Official Crisp Web SDK. No customer identity or orders are synchronized here.
  // Wait for readiness before reading the current draft (get is not async-safe).
  window.$crisp = window.$crisp || [];
  window.CRISP_WEBSITE_ID = d.websiteId;
  const ready = new Promise(resolve => {
    const previousReady = window.CRISP_READY_TRIGGER;
    window.CRISP_READY_TRIGGER = () => {
      resolve(true);
      if (typeof previousReady === 'function') previousReady();
    };
    if (typeof window.$crisp.get === 'function') resolve(true);
    if (!document.querySelector('script[src="https://client.crisp.chat/l.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://client.crisp.chat/l.js';
      script.async = true;
      script.addEventListener('error', () => resolve(false), { once: true });
      document.head.appendChild(script);
    }
  });
  window.$crisp.push(['config', 'locale', [document.documentElement.lang.split('-')[0]]]);
  window.$crisp.push(['config', 'color:theme', ['black']]);
  window.$crisp.push(['config', 'color:mode', ['light']]);

  document.addEventListener('click', async event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download') || !link.closest('main') || link.closest('.legal-page, .legal-content, .legal-contact, .contact-grid')) return;
    const url = new URL(link.href, location.origin);
    if (!contactPath || url.origin !== location.origin || path(url.href) !== contactPath) return;
    event.preventDefault();
    if (activeLink) return;
    activeLink = link;
    const message = messageFor(link);
    const status = document.getElementById('site-status');
    link.setAttribute('aria-busy', 'true');
    if (status) status.textContent = d.loading;
    let timer;
    try {
      const loaded = await Promise.race([ready, new Promise(resolve => { timer = setTimeout(() => resolve(false), 8000); })]);
      if (!loaded) throw new Error('Crisp unavailable');
      const draft = window.$crisp.get('message:text') || '';
      const next = !draft.trim() || draft === previousContext ? message
        : draft.includes(message) ? draft : `${draft}\n\n${message}`;
      window.$crisp.push(['set', 'message:text', [next]]);
      window.$crisp.push(['do', 'chat:open']);
      previousContext = message;
    } catch {
      // No chat action remains queued after timeout; keep the contextual native form.
      url.searchParams.set('subject', message);
      location.assign(url.href);
    } finally {
      clearTimeout(timer);
      link.removeAttribute('aria-busy');
      if (status) status.textContent = '';
      activeLink = null;
    }
  });
})();
